<div class="layout">
  <app-header
    [appName]="appName()"
    [navItems]="_navigationItems()"
    [sidebarEnabled]="_canShowSidebar()"
    [manageAccountUrl]="
      _canShowManageAccounts() ? '/manage-account' : undefined
    "
    [sidebarOpen]="_isSidebarOpen()"
    (menuToggle)="_toggleSidebar()" />

  <div
    class="layout__main-area"
    [class.layout__main-area--sidebar-push]="
      _canShowSidebar() && _isSidebarOpen()
    ">
    <div class="layout-body">
      @if (_canShowSidebar()) {
        <app-sidebar
          [isOpen]="_isSidebarOpen()"
          [navItems]="_navigationItems()"
          [companyName]="companyName()"
          (close)="_closeSidebar()" />
      }

      @if (_canShowSidebar() && _isSidebarOpen()) {
        <div
          class="layout-backdrop"
          (click)="_closeSidebar()"
          aria-hidden="true"></div>
      }

      <main
        class="main-content"
        id="main-content"
        [class.main-content--no-mobile-nav]="!_canShowSidebar()">
        <router-outlet />
      </main>
    </div>

    @if (_canShowSidebar()) {
      <app-mobile-bottom-nav
        [navItems]="_mobileBottomNavItems()"
        [sidebarEnabled]="true"
        (openSidebar)="_openSidebar()" />
    }

    <!-- Footer hidden app-wide (CLA land has no app footer chrome). -->
  </div>

  <app-loading-spinner />
  <app-black-screen-overlay />
  @if (_reauth.isRequired()) {
    <app-reauth-modal />
  }
</div>
